export const GET_WORLDS_SUCCESS = 'GET_WORLDS_SUCCESS';
export const GET_WORLDS_FAILURE = 'GET_WORLDS_FAILURE';
